import { legacy_createStore as createStore, combineReducers, applyMiddleware } from 'redux'
import { thunk } from 'redux-thunk'
import userReducer from '@/store/reducers/userReducer'
import searchReducer from '@/store/reducers/searchReducer'
import { userMiddleware } from './middleware/userMiddleware'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const persistConfig = {
  key: 'protal',
  storage
}

const rootReducer = combineReducers({
  userReducer,
  searchReducer
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = createStore(persistedReducer, applyMiddleware(thunk, userMiddleware))
const persistor = persistStore(store)

export { store, persistor }